var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { UNIFIED_API_PRERELEASE_VERSION } from "../../../../resources/expapiunified/ExpAPIVUnified.constants.js";
import { getFetchArgs, providesList } from "../../utils.js";
import { authoringApi } from "../api.js";
import { URL_SEGMENTS, TAGS } from "../common.js";
const getVariantIdsInComposition = (composition) => {
  var _a, _b;
  return (_b = (_a = composition == null ? void 0 : composition.nodes) == null ? void 0 : _a.flatMap((node) => [node.variantId, ...node.compositionChildren.map((child) => child.variantId)])) != null ? _b : [];
};
const resource = URL_SEGMENTS.VARIANT;
const variantApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    getVariantById: builder.query({
      query: (payload) => getFetchArgs({ resource, payload }),
      providesTags: (result, error, { id }) => [{ type: TAGS.VARIANT, id }]
    }),
    createOrUpdateVariantById: builder.mutation({
      query: (payload) => {
        const fetchArgs = getFetchArgs({ resource, payload, method: "PUT" });
        return __spreadValues({}, fetchArgs);
      },
      invalidatesTags: (result, error, payload) => {
        const variantId = payload.id;
        return [
          { type: TAGS.VARIANT, id: variantId },
          { type: TAGS.VARIANT_COMPOSITION, id: variantId },
          { type: TAGS.VARIANT, id: "LIST" }
        ];
      }
    }),
    queryVariants: builder.query({
      query: (payload) => getFetchArgs({ resource, payload }),
      providesTags: (result) => providesList(result == null ? void 0 : result.value, TAGS.VARIANT)
    }),
    getVariantComposition: builder.query({
      query: (payload) => {
        const fetchArgs = getFetchArgs({ resource, payload, apiVersion: UNIFIED_API_PRERELEASE_VERSION });
        return __spreadProps(__spreadValues({}, fetchArgs), {
          url: `${fetchArgs.url}/composition`
        });
      },
      // Provide tag for every variant id in this tree
      providesTags: (result) => getVariantIdsInComposition(result).map((variantId) => ({ type: TAGS.VARIANT_COMPOSITION, id: variantId }))
    }),
    updateVariantComposition: builder.mutation({
      query: (payload) => {
        const fetchArgs = getFetchArgs({ resource, payload, method: "PUT", apiVersion: UNIFIED_API_PRERELEASE_VERSION });
        return __spreadProps(__spreadValues({}, fetchArgs), {
          url: `${fetchArgs.url}/composition`
        });
      },
      // Invalidate the variant composition tag of every variant in this tree
      invalidatesTags: (result, error, { entity: compositionPayload }) => [
        ...getVariantIdsInComposition(compositionPayload).map((variantId) => ({ type: TAGS.VARIANT_COMPOSITION, id: variantId })),
        ...getVariantIdsInComposition(result).map((variantId) => ({ type: TAGS.VARIANT_COMPOSITION, id: variantId }))
      ]
    })
  })
});
const {
  usePrefetch: usePrefetchVariants,
  useGetVariantByIdQuery,
  useCreateOrUpdateVariantByIdMutation,
  useLazyGetVariantByIdQuery,
  useQueryVariantsQuery,
  useLazyQueryVariantsQuery,
  useGetVariantCompositionQuery,
  useLazyGetVariantCompositionQuery,
  useUpdateVariantCompositionMutation
} = variantApi;
export {
  useCreateOrUpdateVariantByIdMutation,
  useGetVariantByIdQuery,
  useGetVariantCompositionQuery,
  useLazyGetVariantByIdQuery,
  useLazyGetVariantCompositionQuery,
  useLazyQueryVariantsQuery,
  usePrefetchVariants,
  useQueryVariantsQuery,
  useUpdateVariantCompositionMutation,
  variantApi
};
//# sourceMappingURL=variants.js.map
